import PropTypes from 'prop-types';
import React from 'react';

const InfoBannerTypes = {
	INFORM: 'inform',
	AFFIRM: 'affirm',
	WARNING: 'warning',
	ERROR: 'error',
	GUIDE: 'guide',
};

export const InfoBanner = ({ type, children }) => (
	<div className={`common-ui-info-banner ${type || InfoBannerTypes.INFORM}`}>
		{children}
	</div>
);

InfoBanner.propTypes = {
	type: PropTypes.oneOf([
		InfoBannerTypes.INFORM,
		InfoBannerTypes.AFFIRM,
		InfoBannerTypes.WARNING,
		InfoBannerTypes.ERROR,
		InfoBannerTypes.GUIDE,
	]),
	children: PropTypes.node.isRequired,
};

InfoBanner.defaultProps = {
	type: InfoBannerTypes.WARNING,
};
